import styled, { css } from 'styled-components';
import { MenuItemState, MenuItemVariant } from '.';

export type MenuItemStylesProps = {
  $variant: MenuItemVariant;
  $state: MenuItemState;
};

export const Container = styled.div<MenuItemStylesProps>`
  display: flex;
  flex-direction: row;
  flex: 1;

  align-items: center;

  background-color: ${({ theme, $variant, $state }) => {
    if ($state === 'default') return 'none';
    return theme.colors.accent[$variant === 'soft' ? 'accent_alpha' : 'accent'][
      $variant === 'soft' ? '5' : '9'
    ];
  }};

  ${({ theme }) => {
    return css`
      padding-top: ${theme.spacing['4']}px;
      padding-right: ${theme.spacing['5']}px;
      padding-bottom: ${theme.spacing['4']}px;
      padding-left: ${theme.spacing['4']}px;
      gap: ${theme.spacing['3']}px;
      border-radius: ${({ theme }) => theme.radius['2']}px;
    `;
  }}
`;

export const Texto = styled.span<MenuItemStylesProps>`
  ${({ theme }) => {
    return css`
      font-size: ${theme.typography.font.size['2']}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.medium};
      line-height: ${theme.typography.font.line_height['2']}px;
      text-align: center;
    `;
  }};

  color: ${({ theme, $state, $variant }) => {
    if ($state === 'default') return theme.tokens.colors.text;
    if ($state === 'selected') return theme.tokens.colors.black_contrast;
    if ($variant === 'soft') return theme.colors.accent.accent_alpha['11'];
    return theme.colors.accent_contrast;
  }};
`;
